module.exports = "images/location_harbourg.553dbdccffced9d2ba4564095841aa23.png";